import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { ScreensContext } from '../contexts/screensContext';
import WelcomeComponent from '../components/mgm-personalcabinet/welcome-component';
import RulesComponent from '../components/mgm-personalcabinet/rules-component';
import FaqComponent from '../components/mgm-personalcabinet/faq-component';
import PointHistoryComponent from '../components/mgm-personalcabinet/point-history-component';
import QuestionComponent from '../components/mgm-personalcabinet/question-component';
import PointChangeComponent from '../components/mgm-personalcabinet/point-change-component';
import CertificateComponent from '../components/mgm-personalcabinet/certificate-component';
import QrCodeComponent from '../components/mgm-personalcabinet/qr-code-component';
import PhoneComponent from '../components/mgm-personalcabinet/phone-component';
import BarcodeComponent from '../components/mgm-personalcabinet/barcode-component';
import mgmService from '../services/mgmService';
import ErrorComponent from '../components/mgm-personalcabinet/error-component';
import ChangeErrorComponent from '../components/mgm-personalcabinet/change-error-component';
import TermsPopupComponent from '../components/mgm-personalcabinet/terms-popup-component';
import CookieManagementComponent from '../components/mgm-personalcabinet/cookie-management-component';

const TERMS_ACCEPTED_KEY = 'mgm_terms_accepted';

const PersonalCabinet = () => {
  const [screenNumber, setScreenNumber] = useState(1);
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [pointChangeTab, setPointChangeTab] = useState('offers');
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const [isTermsAccepted, setIsTermsAccepted] = useState(
    () => localStorage.getItem(TERMS_ACCEPTED_KEY) === 'true'
  );
  const { init } = useContext(DataLayerEventContext);

  const handleAcceptTerms = () => {
    localStorage.setItem(TERMS_ACCEPTED_KEY, 'true');
    setIsTermsAccepted(true);
  };

  useEffect(() => {
    init('MGM-PersonalCabinet');
  }, [init]);

  useEffect(() => {
    (async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const telegramId = urlParams.get('telegram_id');

        if (telegramId) {
          const data = await mgmService.mgmAuth(telegramId);

          if (data?.accessToken) {
            localStorage.setItem('m_a_t', data.accessToken);
            return;
          }
        }

        setScreenNumber(100);
      } catch (error) {
        setScreenNumber(100);
      } finally {
        setIsAuthLoading(false);
      }
    })();
  }, []);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <WelcomeComponent
            setScreenNumber={setScreenNumber}
            onChangePointClick={() => {
              setPointChangeTab('offers');
              setScreenNumber(4);
            }}
            onCertificatesClick={() => {
              setPointChangeTab('certificates');
              setScreenNumber(4);
            }}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 2: {
        return (
          <RulesComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 3: {
        return (
          <PointHistoryComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 4: {
        return (
          <PointChangeComponent
            initialTab={pointChangeTab}
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
            onCertificateClick={(certificate) => {
              setSelectedCertificate(certificate);
              setScreenNumber(5);
            }}
            onRewardClick={(certificate) => {
              setSelectedCertificate(certificate);
              setScreenNumber(8);
            }}
          />
        );
      }
      case 5: {
        return (
          <CertificateComponent
            selectedCertificate={selectedCertificate}
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
            onBought={(reward) => {
              setSelectedCertificate(reward);
              setScreenNumber(8);
            }}
          />
        );
      }
      case 6: {
        return (
          <QrCodeComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 7: {
        return (
          <PhoneComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 8: {
        return (
          <BarcodeComponent
            selectedCertificate={selectedCertificate}
            setScreenNumber={setScreenNumber}
            onBack={() => {
              setPointChangeTab('certificates');
              setScreenNumber(4);
            }}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 9: {
        return (
          <ChangeErrorComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
            onMainPageButtonClick={() => setScreenNumber(1)}
          />
        );
      }
      case 10: {
        return (
          <FaqComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 11: {
        return <CookieManagementComponent setScreenNumber={setScreenNumber} />;
      }
      default: {
        return <ErrorComponent setScreenNumber={cb} />;
      }
    }
  };
  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, setScreenNumber)}
      {isQuestionOpen && (
        <QuestionComponent onClose={() => setIsQuestionOpen(false)} />
      )}
      {!isTermsAccepted && screenNumber === 1 && (
        <TermsPopupComponent
          onAgree={handleAcceptTerms}
          onDisagree={() => {}}
          onRulesClick={() => setScreenNumber(2)}
        />
      )}
    </ScreensContext.Provider>
  );
};

export default PersonalCabinet;
